import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import { AuthProvider } from '@/auth/AuthContext';
import { queryClient } from '@/services/query';
import { router } from '@/app/routes';
import { Spinner } from '@/components/ui';
import '@/theme/index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Suspense
          fallback={
            <div className="flex h-full items-center justify-center">
              <Spinner />
            </div>
          }
        >
          <RouterProvider router={router} />
        </Suspense>
        <Toaster richColors closeButton position="top-right" theme="system" toastOptions={{ className: 'text-sm' }} />
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
